<div class="card text-center">
    <div class="card-block">
        <form [formGroup]="cancelServiceForm">
            <div class="row">
                <div class="col-sm-2">
                    <div class="form-group">
                        <sanabel-selectize appcode="1058" formControlName="cancelReasonHeader">
                        </sanabel-selectize>
                    </div>
                </div>
                <div class="col-sm-10">
                    <label for="notes">{{ 'NOTES' | translate }}</label>
                    <textarea class="form-control" rows="4" id="notes" formControlName="cancelReason"
                        name="cancelReason"></textarea>
                </div>
                <div *ngIf="patService.showSmsMsg">
                    <input type="checkbox" [ngModelOptions]="{standalone: true}" name="sendMessageFlag" [(ngModel)]="patService.sendMessageFlag">Send sms Message
                </div>
            </div>
            <div class="container-fluid">
                <div class="row">
                    <div class="col">
                        <btns-ctrl [appCodes]="[1]" (clicked)="onClicked($event)"></btns-ctrl>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>